import React, { useContext, useEffect, useState } from "react";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../Context/Context";


export const Instructuctivos = () => {

    const [state] = useContext(AppContext);
    const [descripcion, setdescripcion] = useState(null);
    const id = atob(sessionStorage.getItem("dtpln"));

    let plan = null;
    if (state.data !== null) {
        const planes = state.data.Usuario.Datos.Planes.Plan;
        plan = planes.filter(plan => plan.Id === id)[0];
    }

    return (
        <div>
            <Menu />
            <div className="wrap">
                <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                <div className="next-to-sidebar">
                    <div className="instructivos">
                        <div className="instructivos_mainDiv mt-dbhf">
                            <div className="instructivos_mainDiv--user">
                                <p>Instructivos</p>
                                <div className="separator--hor mt-half mb-half"></div>
                            </div>
                            <div className="instructivos_mainDiv--buttons">
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo Clientes_Red Banelco_FIAT.pdf">
                                        <button >
                                            <span>Pago por Home Banking Banelco</span>{" "}
                                            <img src="/images/icons/download.svg" />{" "}
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo Clientes_Pago Home Banking Link_FIAT.pdf">
                                        <button>
                                            <span>Pago por Home Banking Link</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo Clientes_Mercado Pago_FIAT.pdf">
                                        <button>
                                            <span>Pago desde la App MercadoPago</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo Clientes_ProvinciaNET_FIAT.pdf">
                                        <button>
                                            <span>Pago desde Provincia NET</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo Clientes_Pago por QR_FIAT.pdf">
                                        <button>
                                            <span>Pago desde el código QR</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Intructivo licitación online - Fiat 1.pdf">
                                        <button>
                                            <span>Licitación online</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/Instructivo FIAT - COMO LEER MI CUOTA.pdf">
                                        <button>
                                            <span>¿Como leer mi cuota?</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/instructivo_pago_mis_cuentas.pdf">
                                        <button>
                                            <span>Pago por Pago Mis Cuentas</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                                <div className="instructivos_mainDiv--buttons--button">
                                    <a target="_blank" href="pdf/instructivos/instructivo_pago_web.pdf">
                                        <button>
                                            <span>Pagar desde de la web Leapmotor Plan</span>
                                            <img src="/images/icons/download.svg" />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
